// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"FullB_TheComp__6smtX","swiperTool":"FullB_swiperTool___EwDR"};